import i18n from "@/lib/i18n";
import api from "@/lib/api";

// Switch the UI language (persisted locally) without touching the account.
export function applyUiLanguage(lang) {
  if (lang !== "fr" && lang !== "en") return;
  if (!i18n.language?.startsWith(lang)) i18n.changeLanguage(lang);
  localStorage.setItem("qrise_lang", lang);
}

// Explicit FR/EN choice: also remembered on the logged-in account.
export function chooseUiLanguage(lang, user, setUser) {
  applyUiLanguage(lang);
  if (!user || user.language === lang) return;
  setUser?.({ ...user, language: lang });
  api.patch("/auth/me/language", { language: lang }).catch(() => {});
}
